__turbopack_context__.v({
  "icon": "search-bar-module__RaT9ga__icon",
  "input": "search-bar-module__RaT9ga__input",
  "wrapper": "search-bar-module__RaT9ga__wrapper",
});
